import { Skeleton } from 'antd'
import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { RouterLink } from '@eastcoal/router/components/Link'

import { HomeProListItem, HomeProListProps } from './interface'

const useStyles = createStyles(({ prefixCls, token }) => ({
  list: {
    paddingInline: token.paddingSM
  },
  item: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    columnGap: token.marginXS,
    paddingInline: token.paddingSM,
    paddingBlock: token.paddingSM,
    borderBlockEnd: `1px solid ${token.colorBorderSecondary}`
  },
  icon: {
    flex: 'none',
    alignSelf: 'flex-start'
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  title: {
    marginBlockStart: 2,
    color: token.colorText,
    fontSize: token.fontSizeHeading5,
    lineHeight: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  desc: {
    marginBlockStart: token.marginXS
  },
  extra: {
    flex: 'none',
    color: token.colorTextTertiary
  }
}))

const Item = ({
  styles: externalStyles,
  detailPath,
  id,
  icon,
  title,
  desc,
  extra
}: HomeProListItem & Pick<HomeProListProps, 'styles' | 'detailPath'>) => {
  const { styles } = useStyles()

  const iconDom = !isNil(icon) && (
    <div className={styles.icon} style={externalStyles?.icon}>
      {icon}
    </div>
  )

  const contentDom = (
    <div className={styles.content}>
      <div className={styles.title} style={externalStyles?.title}>
        {detailPath ? (
          <RouterLink
            newtab
            type='text'
            to={stringifyUrl({
              url: detailPath,
              query: { id }
            })}
          >
            {title}
          </RouterLink>
        ) : (
          title
        )}
      </div>
      {desc && (
        <div className={styles.desc} style={externalStyles?.desc}>
          {desc}
        </div>
      )}
    </div>
  )

  const extraDom = !isNil(extra) && (
    <div className={styles.extra} style={externalStyles?.extra}>
      {extra}
    </div>
  )

  return (
    <div className={styles.item} style={externalStyles?.item}>
      {iconDom}
      {contentDom}
      {extraDom}
    </div>
  )
}

export const HomeProList = ({
  className,
  style,
  loading,
  dataSource,
  ...restProps
}: HomeProListProps) => {
  const { cx, styles } = useStyles()

  return (
    <Skeleton loading={loading}>
      <div className={cx(styles.list, className)} style={style}>
        {dataSource.map(({ id, ...restItem }) => (
          <Item {...restProps} key={id} id={id} {...restItem} />
        ))}
      </div>
    </Skeleton>
  )
}
